export default function initGoogleMap() {
// In the following example, markers appear when the user clicks on the map.
// The markers are stored in an array.
// The user can then click an option to hide, show or delete the markers.
    let map;
    let markers = [];
    let circles = [];

    function initMap() {
        if($('#map').length > 0) {
            const centralEurope = new google.maps.LatLng('52.26691427824503', '5.650015179128305');
            const dealers = JSON.parse(document.querySelector('#map')
              .getAttribute('data-dealers'));
            const styles = require('./includes/google-maps-styling.json');

            map = new google.maps.Map(document.getElementById("map"), {
                zoom: 7,
                center: centralEurope,
                styles: styles
            });

            for (let key in dealers) {
                addMarker(dealers[key]);
            }

            $('#dealer-lookup')
              .on('submit', function (e) {
                  e.preventDefault();

                  $.ajax({
                      method: $(this)
                        .attr('method'),
                      url: $(this)
                        .attr('action'),
                      data: $(this)
                        .serialize(),
                      success: function (json) {
                          const dealers = JSON.parse(json.data);
                          const allDealers = JSON.parse(json.allDealers);
                          const searchLocation = json.searchLocation;

                          // Remove all
                          removeMarkers();
                          removeCircles();

                          if (dealers.length > 0) {
                              for (let key in dealers) {
                                  addMarker(dealers[key]);
                              }
                              addCircle(searchLocation);
                              $("#successMessage")
                                .html("");
                          } else {
                              for (let key in allDealers) {
                                  addMarker(allDealers[key]);
                              }

                              map.setCenter(centralEurope);
                              map.setZoom(7);

                              $("#successMessage")
                                .html("Geen resultaten");
                          }
                      },
                      error: function (xhr) {
                          switch (xhr.status) {
                          case 404:
                              // netjes afvangen ;)
                              break;
                          }
                          console.error(xhr);
                      }
                  })

                  return false;
              });
        }
    }

    function removeCircles() {
        // Clear markers
        for (let i = 0; i < circles.length; i++) {
            circles[i].setMap(null);
        }
        circles = [];
    }

// Add a radius to show what covers your search
    function addCircle(searchLocation) {
        const center = {lat: searchLocation.lat, lng: searchLocation.lng};
        const radius = searchLocation.range;
        const circle = new google.maps.Circle({
            strokeColor: '#003366',
            strokeOpacity: 0.7,
            strokeWeight: 2,
            fillColor: '#116e98',
            fillOpacity: 0.30,
            map: map,
            center: center,
            radius: radius * 1000
        });
        circles.push(circle);

        map.setCenter(center);
        map.setZoom(Math.round(14 - Math.log(radius) / Math.LN2));
    }

    function removeMarkers() {
        // Clear markers
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];
    }

// Adds a marker to the map and push to the array.
    function addMarker(location) {
        const latLng = new google.maps.LatLng(location.lat, location.lng);
        const marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: '/img/custom/awesome-map-marker-alt.png'
        });
        markers.push(marker);

        location.suffix = (location.suffix != null) ? location.suffix : '';
        location.email = (location.email != null) ? '<strong>E-mail: </strong><a style="text-decoration: underline" href="mailto:'+location.email+'">'+location.email+'</a><br/>' : '';
        location.telephone = (location.telephone != null) ? '<strong>Telefoon: </strong><a style="text-decoration: underline" href="tel:'+location.telephone+'">'+location.telephone+'</a><br/>' : '';
        location.website = (location.website != null) ? '<strong>Website: </strong><a style="text-decoration: underline" target="_blank" href="'+location.website+'">'+location.website+'</a><br/>' : '';

        const infowindow = new google.maps.InfoWindow();
        const content = `${location.title}<br/>
                         ${location.street} ${location.house_number} ${location.suffix}<br/>
                         ${location.zipcode}<br/>
                         ${location.city}<br/>
                         ${location.email}
                         ${location.telephone}
                         ${location.website}`;

        google.maps.event.addListener(marker, 'click', (function (marker) {
            return function () {
                infowindow.setContent(content);
                infowindow.open(map, marker);
            }
        })(marker));
    }

    initMap();
}
